import { ReactComponent as GolfIcon } from "icons/m2c-golf.svg";
import { ReactComponent as LaunchIcon } from "icons/m2c-launch.svg";
import { ReactComponent as AthelticsIcon } from "icons/athleticsLogo.svg";
import { ReactComponent as SimulationIcon } from "icons/simulationProject.svg";
import { ReactComponent as AnalyticsIcon } from "icons/analytics-project.svg";
import { ReactComponent as TonalLogo } from "icons/tonalLogo.svg";
import { DashboardSideMenu, InboxSideMenu, SmilesLogoSidebar } from "icons";

export interface MenuItem {
  key: React.Key;
  icon?: React.ReactNode;
  label: React.ReactNode;
  children?: MenuItem[];
}

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  onClick?: () => void, // Accept onClick function as a parameter
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  };
}

const CustomIconWrapper = ({ children }: any) => (
  <div
    style={{
      border: "#cd2a3f9",
      verticalAlign: "middle",
      display: "flex",
      justifyContent: "center",
      alignItems: "center", // Add alignItems property for vertical centering
      height: "35px",
      width: "35px",
      marginRight: "inherit",
      borderRadius: "5px",
      backgroundColor: "white",
    }}
  >
    {children}
  </div>
);

export const items: MenuItem[] = [
  getItem(
    "Dashboard",
    "sub1",
    <CustomIconWrapper>
      <SmilesLogoSidebar />
    </CustomIconWrapper>,
    [
      getItem("Lawsuits", "2", <DashboardSideMenu height={15} width={15} />),
      getItem("inboxText", "3", <InboxSideMenu height={15} width={15} />),
    ],
  ),
];

export function getOpenKeys(key: any) {
  const sub1 = ["1", "2", "3"];
  const sub2 = ["4", "5", "6"];
  const sub3 = ["7", "8", "9"];
  const sub4 = ["13", "14"];
  const sub5 = ["15", "16"];
  if (sub1.includes(key)) return ["sub1"];
  if (sub2.includes(key)) return ["sub2"];
  if (sub3.includes(key)) return ["sub3"];
  if (sub4.includes(key)) return ["sub4"];
  if (sub5.includes(key)) return ["sub5"];
}
